import { ua } from '../ua';

function replaceCss (options) {
  if (ua.browser !== 'IE') return;
  import(/* webpackChunkName: "ie-polyfill" */ './cssVar').then(m => {
    if (m.default && typeof m.default === 'function') {
      m.default(options);
    }
  });
}

export default replaceCss;
